import { Component, OnDestroy, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { ExportButtonTileComponent } from '../export-button-tile/export-button-tile.component';

@Component({
  standalone: false,
  selector: 'suvo-bi-advanced-export-tile',
  templateUrl: './advanced-export-tile.component.html',
  styleUrls: ['./advanced-export-tile.component.scss'],
})
export class AdvancedExportTileComponent
  extends ExportButtonTileComponent
  implements OnDestroy, OnInit
{
  numberOfFilters = 0;
  isExporting = false;

  optionsForm: FormGroup;
  fileNameControl: FormControl;

  ngOnInit() {
    this.fileNameControl = new FormControl('export-file', [
      Validators.required,
      Validators.maxLength(64),
      // Validators.pattern(new RegExp(/^\w+/g))
    ]);
    this.optionsForm = new FormGroup({
      fileName: this.fileNameControl,
    });
    this.filtersChannel?.filters.pipe(takeUntil(this.unsubscribe$)).subscribe((filters) => {
      this.numberOfFilters = filters?.query?.rules?.length || 0;
    });
  }

  getFileNameError(): string {
    if (this.fileNameControl.hasError('required')) {
      return 'File name required.';
    }
    if (this.fileNameControl.hasError('maxLength')) {
      return 'File name too long.';
    }
    if (this.fileNameControl.hasError('pattern')) {
      return 'Invalid file name.';
    }
  }

  async export() {
    if (this.isExporting || this.optionsForm.invalid) {
      return;
    }

    const dataSourceAlias = this.tileInstance.dataSource;
    const filters = this.filtersChannel.filters.getValue();
    const fileName = this.fileNameControl.value;

    this.exportDataSourceItems(dataSourceAlias, filters, fileName);
  }
}
